import { apiCall } from "api-calls/api-call"
import { AbExperiment, UpdateVariantForceAccountsData } from "../store/types"

export const listAbExperiments = async(
  name?: string,
  includeEnded?: boolean,
): Promise<AbExperiment[]> => {
  return apiCall({
    method: "GET",
    path: "buff-play/ab-testing/experiments",
    query: { ...(name ? { name } : {}), ...(includeEnded ? { includeEnded: "true" } : {}) },
  })
}

export const getAbExperiment = async(name: string): Promise<AbExperiment> => {
  return apiCall({
    method: "GET",
    path: `buff-play/ab-testing/experiments/${encodeURIComponent(name)}`,
  })
}

export const setAbExperiment = async(data: {
  name: string;
  variants: Array<{
    name: string;
    upperCutoffPercentage: number;
    forceOnAccountIds?: string[];
    forceOffAccountIds?: string[];
    payload?: Record<string, unknown>;
  }>;
}): Promise<AbExperiment> => {
  return apiCall({
    method: "POST",
    path: "buff-play/ab-testing/experiments",
    body: data,
  })
}

export const endAbExperiment = async(name: string): Promise<{ success: boolean }> => {
  return apiCall({
    method: "DELETE",
    path: `buff-play/ab-testing/experiments/${encodeURIComponent(name)}`,
  })
}

export const updateAbVariantForceAccounts = async(
  experimentName: string,
  variantName: string,
  data: UpdateVariantForceAccountsData,
): Promise<AbExperiment> => {
  return apiCall({
    method: "PATCH",
    // eslint-disable-next-line max-len
    path: `buff-play/ab-testing/experiments/${encodeURIComponent(experimentName)}/variants/${encodeURIComponent(variantName)}/force-accounts`,
    body: data,
  })
}

export const updateAbVariantsForceAccounts = async(
  experimentName: string,
  data: Record<string, UpdateVariantForceAccountsData>,
): Promise<AbExperiment> => {
  return Promise.all(
    Object.entries(data).map(
      ([variantName, forceAccountsData]) => updateAbVariantForceAccounts(experimentName, variantName, forceAccountsData),
    ),
  )
    .then(() => getAbExperiment(experimentName))
}
